import React from "react"
import PropTypes from "prop-types"

import { SORT_HORA, SORT_NOMBRE } from "../static"

const ClientsToolbar = ({
  search,
  sort,
  onlyChanged,
  listadoLabel,
  onSearch,
  onSort,
  onToggleOnlyChanged,
}) => (
  <div className="cfg-toolbar">
    <div className="cfg-toolbar-title">Clientes</div>

    <div className="cfg-search">
      <i className="bx bx-search" />
      <input
        value={search}
        placeholder="Buscar cliente…"
        onChange={event => onSearch(event.target.value)}
      />
    </div>

    <span className="cfg-count">{listadoLabel}</span>

    <div className="d-flex align-items-center" style={{ gap: "7px" }}>
      <span className="cfg-label" style={{ whiteSpace: "nowrap" }}>
        Ordenar por
      </span>
      <div className="cfg-seg">
        <button
          type="button"
          className={sort !== SORT_HORA ? "is-on" : ""}
          onClick={() => onSort(SORT_NOMBRE)}
        >
          Nombre A–Z
        </button>
        <button
          type="button"
          className={sort === SORT_HORA ? "is-on" : ""}
          onClick={() => onSort(SORT_HORA)}
        >
          Hora de inicio
        </button>
      </div>
    </div>

    <button
      type="button"
      className={`cfg-btn-toggle${onlyChanged ? " is-on" : ""}`}
      onClick={() => onToggleOnlyChanged(!onlyChanged)}
    >
      Solo modificados
    </button>
  </div>
)

ClientsToolbar.propTypes = {
  search: PropTypes.string,
  sort: PropTypes.string,
  onlyChanged: PropTypes.bool,
  listadoLabel: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  onToggleOnlyChanged: PropTypes.func.isRequired,
}

export default ClientsToolbar
